module.exports = __webpack_public_path__ + "static/casava-eaa5ddd106989421bd73f97f8c9e7926.jpg";